<template>
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M19 4.188c1.162.414 2 1.513 2 2.817a2.996 2.996 0 0 1-2 2.816V4.188zM3 3.004v8H2c-1.104 0-2-.897-2-2v-4c0-1.103.896-2 2-2h1zM17.615.217a.998.998 0 0 1 .385.787v12a1 1 0 0 1-1.242.97L6 11.285v1.385l2.8 3.735-1.6 1.199-3-4a.995.995 0 0 1-.2-.6v-10h.877L16.758.033c.297-.074.614-.006.857.184z"
        id="a"
      />
    </defs>
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path d="M-1-4h24v24H-1z"/>
      <use
        fill="#fff"
        fill-rule="nonzero"
        xlink:href="#a"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AudioPlayIcon'
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/AudioPlayIcon.vue